<script>
	import { geoMercator,scaleOrdinal } from "d3";
	import MapboxMap from './MapboxMap.svelte';
	import SvgMap from './SvgMap.svelte'
	import LayerSwitcher from './LayerSwitcher.svelte'
  import Legend from "./Legend.svelte";
  import Tooltip from "./Tooltip.svelte";


  let step = 0
  let hovered
  let quantity = '_overall'
  let etype = 'NO2'
  
	
	// This geoJSON is used to sync the Mapbox map and the SVG map
	let geoJsonToFit = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [1, 0],
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [0, 1],
        },
      },
    ],
  };
	
	let width;
	let height;

  let legend_type = 'no2'

  $: projection = geoMercator().fitSize([width, height], geoJsonToFit);
  $: console.log(step)
  $: step<0?step=0:step=step;
	
	let activeLayer = 'concentric';

  function clickup() {
		step+=1
	}




let keys = ['0-10', '10-20', '20-30', '30-40', '40-50','50+']
let keys2 = ['0-5', '5-10', '10-15', '15-20', '20-25','25+']


let colors = ["#005B3C","#71BC77","#FFDE8B","#FE8BC7","#FA55A4","#CE358C"]

let colorScale = scaleOrdinal()
    .domain(keys) // continents was already defined in our code
    .range(colors);


    let colorScale2 = scaleOrdinal()
    .domain(keys2) // continents was already defined in our code
    .range(colors);

  
</script>

<div class="maps-container" bind:clientWidth={width} bind:clientHeight={height}>
	<MapboxMap bind:geoJsonToFit>
	</MapboxMap>
	<div class="svg-map-container">
			<SvgMap {width} {height} {projection} {activeLayer}{step}{hovered}{colors}{quantity}{etype}></SvgMap>
	</div>
</div>

<Tooltip {height}{step}{etype} />


<LayerSwitcher bind:quantity bind:etype></LayerSwitcher>

{#if etype == 'NO2'}
<Legend {colorScale}  {step} {legend_type} bind:hovered/>
{/if}

{#if etype == 'PM25'}
<Legend colorScale={colorScale2} {step} {legend_type} bind:hovered/>
{/if}



<button class='button2' on:click={clickup}>
	Start
</button>

<style>


@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;600&display=swap');



  .maps-container {
    width: (100%-250px);
    margin-left: 250px;
    margin-right:-10px;
    margin-top:-10px;
    height: 100vh;
    position: relative;
  }
	.svg-map-container {
    position: absolute;
    top: 0;
    left: 0;
		pointer-events: none;
  }

  .button1 {
		position: fixed;
		bottom: 16px;
		left: 100px;
    width: 100px;
		padding: 4px;
		border-radius: 2px;
    font-family: Arial;

	}

  .button2 {
		position: fixed;
		bottom: 16px;
		left: 80px;
    width: 100px;
		padding: 4px;
		border-radius: 2px;
    font-family: Arial;
	}



</style>